module.exports = __webpack_public_path__ + "static/media/amoo.b53de703.png";